var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarmitzva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 44,
    viewBox: "0 0 26 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBE5",
    d: "M14.837 4.015l.8-1.387c.117-.201-.029-.455-.263-.455h-1.6l-.654-1.131c-.117-.204-.41-.204-.526 0l-.654 1.13h-1.6c-.234 0-.381.255-.264.456l.801 1.387-.801 1.386c-.117.203.03.457.264.457h1.6l.654 1.13c.116.204.409.204.526 0l.653-1.13h1.601c.234 0 .38-.254.263-.457l-.8-1.386zM4.629 36.774L21.317 36.774 21.317 22.751 4.629 22.751z",
    transform: "translate(.805 .496)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9BDBA",
    d: "M3.206 39.512C1.656 39.512.4 38.256.4 36.707V22.609c0-1.55 1.256-2.806 2.806-2.806s2.806 1.256 2.806 2.806v14.098c0 1.549-1.256 2.805-2.806 2.805",
    transform: "translate(.805 .496)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9BDBA",
    d: "M3.203 17.825c-.32 0-.58.259-.58.58v2.58c0 .319.26.58.58.58.32 0 .58-.261.58-.58v-2.58c0-.321-.26-.58-.58-.58M3.203 37.643c-.32 0-.58.259-.58.58v2.58c0 .319.26.58.58.58.32 0 .58-.261.58-.58v-2.58c0-.321-.26-.58-.58-.58",
    transform: "translate(.805 .496)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9BDBA",
    d: "M4.256 17.653c0 .581-.471 1.053-1.053 1.053-.581 0-1.053-.472-1.053-1.053S2.622 16.6 3.203 16.6c.582 0 1.053.472 1.053 1.053M22.157 39.512c-1.55 0-2.806-1.256-2.806-2.805V22.609c0-1.55 1.257-2.806 2.806-2.806 1.55 0 2.807 1.256 2.807 2.806v14.098c0 1.549-1.257 2.805-2.807 2.805",
    transform: "translate(.805 .496)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9BDBA",
    d: "M22.157 17.825c-.32 0-.58.259-.58.58v2.58c0 .319.26.58.58.58.32 0 .58-.261.58-.58v-2.58c0-.321-.26-.58-.58-.58M22.157 37.643c-.32 0-.58.259-.58.58v2.58c0 .319.26.58.58.58.32 0 .58-.261.58-.58v-2.58c0-.321-.26-.58-.58-.58",
    transform: "translate(.805 .496)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9BDBA",
    d: "M23.21 17.653c0 .581-.471 1.053-1.053 1.053-.581 0-1.053-.472-1.053-1.053s.472-1.053 1.053-1.053c.582 0 1.053.472 1.053 1.053",
    transform: "translate(.805 .496)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarmitzva);
export default __webpack_public_path__ + "static/media/barmitzva.a828ec50a44b3d038e40b1c252b0f2f9.svg";
export { ForwardRef as ReactComponent };